/**
 * The row a step is about to occupy. It borrows the real row's anatomy —
 * connector, numbered node, the same card — so what you see is the sequence
 * growing, not a status line parked underneath it. Dashed and pulsing is what
 * separates it from a step that exists.
 */
export const PendingStep = ({ index, label }: { index: number; label: string }) => (
  <div className="flex min-w-0 gap-3">
    <div className="flex flex-col items-center">
      {/* Joins the step above, so it reads as the next link in the chain. */}
      <span className="h-2 w-px bg-outline" />
      <span className="flex h-6 w-6 flex-none animate-pulse items-center justify-center rounded-full border border-dashed border-outline-strong bg-surface-elevated text-[0.68rem] font-semibold text-ink-subtle">
        {index}
      </span>
    </div>
    <div className="mt-2 min-w-0 flex-1 rounded-lg border border-dashed border-outline-strong bg-surface px-3 py-2">
      <div className="flex min-w-0 items-center gap-2">
        <span className="h-2.5 w-12 flex-none animate-pulse rounded bg-surface-hover" />
        <span className="h-2.5 w-40 animate-pulse rounded bg-surface-hover" />
        <span className="h-2.5 w-16 animate-pulse rounded bg-surface-hover" />
      </div>
      <p className="mt-1.5 text-xs text-ink-subtle">{label}</p>
    </div>
  </div>
);
